'use client';

import { useGetMatchesQueryData } from '@/app/(default)/(leagues)/leagues/[slug]/session/[sessionId]/matchdate/[matchDateId]/queries';
import { Session } from '@/lib/getSessionPages';
import MatchesWrapper from '@/modules/league/new-components/matches-components/MatchesComponent/MatchesWrapper';
import { GameDayInfo, Round } from '@/modules/league/new-components/types';
import Loader from '@pickleballinc/features/src/Loader/Loader';
import { notFound, useSearchParams } from 'next/navigation';

interface MatchesContentProps {
  params: { slug: string; sessionId: string; matchDateId: string };
  headerContent: GameDayInfo;
  user?: Session;
  currentSequenceNumber: number;
  rounds: { sequences: Round[] };
  isAuthorized: boolean;
}

const MatchesContent = ({
  params,
  headerContent,
  user,
  currentSequenceNumber,
  rounds,
  isAuthorized,
}: MatchesContentProps) => {
  const { matchDateId } = params;
  const searchParams = useSearchParams();
  const selectedMatchGroup = searchParams?.get('matchGroup');
  const selectedPoolID =
    selectedMatchGroup ||
    headerContent.details.CurrentUser_PoolID ||
    headerContent.details.CurrentUser_PoolID_Sequence1 ||
    headerContent.details.PoolID_1stPool_Sequence1 ||
    '';
  const isRatingLeague = headerContent.details.isRatingLeague;
  const isMatchStarted = headerContent.details.isMatchStarted ? true : false;
  const { data, isLoading } = useGetMatchesQueryData(
    matchDateId,
    selectedPoolID,
    currentSequenceNumber,
    isRatingLeague,
    isMatchStarted
  );

  if (isLoading) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <Loader backgroundColor='bg-leagues-300/90' />
      </div>
    );
  }

  if (!data) {
    return notFound();
  }

  return (
    <MatchesWrapper
      headerContent={headerContent}
      user={user}
      matchesResult={data.matchesResult}
      rounds={rounds}
      benchGroup={data.benchGroup}
      allPlayersForRemove={data.allPlayersForRemove}
      sequenceStats={data.sequenceStats}
      isAuthorized={isAuthorized}
    />
  );
};

export default MatchesContent;
